// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface Leaderboard {
  id: string;
  authoritative: boolean;
  sort_order: number;
  operator: number;
  reset_schedule?: string;
  metadata?: string;
  create_time: string;
  category?: number;
  description?: string;
  duration?: number;
  end_time?: string;
  join_required?: boolean;
  max_size?: number;
  max_num_score?: number;
  title?: string;
  size?: number;
  start_time?: string;
}

export interface LeaderboardList {
  leaderboards: Leaderboard[];
  cursor?: string;
}

export interface LeaderboardRecord {
  leaderboard_id: string;
  owner_id: string;
  username?: string;
  score: string;
  subscore: string;
  num_score: number;
  metadata?: string;
  create_time: string;
  update_time: string;
  expiry_time?: string;
  rank?: number;
}

export interface LeaderboardRecordList {
  records: LeaderboardRecord[];
  owner_records?: LeaderboardRecord[];
  next_cursor?: string;
  prev_cursor?: string;
  rank_count?: number;
}

export interface LeaderboardSearchFilters {
  leaderboard_id?: string;
  category?: number;
  authoritative?: boolean;
}

export interface LeaderboardRecordSearchFilters {
  owner_ids?: string[];
  limit?: number;
  cursor?: string;
  expiry?: string;
}

export interface CreateLeaderboardRequest {
  leaderboard_id: string;
  authoritative?: boolean;
  sort_order?: number;
  operator?: number;
  reset_schedule?: string;
  metadata?: string;
  category?: number;
  description?: string;
  duration?: number;
  end_time?: string;
  join_required?: boolean;
  max_size?: number;
  max_num_score?: number;
  title?: string;
  start_time?: string;
}

export interface DeleteLeaderboardRequest {
  leaderboard_id: string;
}

export interface WriteLeaderboardRecordRequest {
  leaderboard_id: string;
  record: {
    owner_id: string;
    username?: string;
    score?: string;
    subscore?: string;
    metadata?: string;
  };
}

export interface DeleteLeaderboardRecordRequest {
  leaderboard_id: string;
  owner_id: string;
}

export enum LeaderboardOperator {
  NO_OP = 0,
  BEST = 1,
  SET = 2,
  INCREMENT = 3,
  DECREMENT = 4
}

export enum LeaderboardSortOrder {
  ASCENDING = 0,
  DESCENDING = 1
}

export interface LeaderboardTournament {
  id: string;
  title?: string;
  description?: string;
  category?: number;
  sort_order?: number;
  size?: number;
  max_size?: number;
  max_num_score?: number;
  can_enter?: boolean;
  end_active?: number;
  end_time?: string;
  next_reset?: number;
  metadata?: string;
  create_time?: string;
  start_time?: string;
  duration?: number;
}
